import { Component, ElementRef, EventEmitter, HostListener, Input, Output, ViewChild, NgZone } from '@angular/core';
import { Toast } from 'app/shared/toast/toast';
import { Mimetype } from 'app/shared/mimetype';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { IdexService } from 'app/idex.service';
import { MatLegacyDialog as MatDialog, MatLegacyDialogRef as MatDialogRef} from '@angular/material/legacy-dialog';
import {ConfirmDeleteComponent} from '../confirm-delete/confirm-delete.component';
import { GoogleDriveMoveDialogComponent } from '../google-drive-move-dialog/google-drive-move-dialog.component';

declare let $: any;
declare const google: any;
declare const google_id: string;
@Component({
   selector: 'app-google-drive-list',
   templateUrl: './google-drive-list.component.html',
   styleUrls: ['./google-drive-list.component.css']
})
export class GoogleDriveListComponent {
   private readonly SCOPE = 'https://www.googleapis.com/auth/drive.readonly';
   items: any[] = [];
   public paths: any[] = [];
   folderId = '';
   @Input() selectedItems: any[];
   @Input() search = false;
   @Input() trash = false;
   @Input() role = 'Admin';
   @Input() tin;
   @Input() shared = false;
   @Input() canDrag = true;
   @Output() clickitem = new EventEmitter<any>();
   @Output() loadmore = new EventEmitter<any>();
   @Output() showdocument = new EventEmitter<any>();
   @Output() searchpos = new EventEmitter<number>();
   @Output() uploadNewVersion = new EventEmitter<any>();
   loading: boolean;
   nativeElement: any;
   @ViewChild('description') descElement: ElementRef;
   isCheck: any;
   extention = '';
   saveText = 'Save';
   post = 'ส่ง';
   shiftPressed = false;
   info: any;
   activeItem: any;
   access_token: any;
   hasMore: boolean;
   navigatingAway: boolean = false;
   private movedialog: MatDialogRef<GoogleDriveMoveDialogComponent>;
   private spacer = 20 + 38; // docList padding 20px + .content-container padding-bottom 38px

   constructor(private router: Router, public service: IdexService, private toast: Toast, private route: ActivatedRoute,
      private elementRef: ElementRef, private translate: TranslateService, public dialog: MatDialog, private zone: NgZone) {
      this.nativeElement = this.elementRef.nativeElement;
      this.translate.get('send').subscribe(s => {
         this.post = s;
      });
      this.translate.get('save').subscribe(s => {
         this.saveText = s;
      });
   }

   setItems(items: any[], hasMore: boolean) {
      this.zone.run( () => {
         this.items = items;
         this.loading = false;
         this.hasMore = hasMore;
      });
   }

   addItems(items: any[], hasMore: boolean) {
      if (items && items.length > 0) {
         this.items.push.apply(this.items, items);
      }
      this.hasMore = hasMore;
      this.loading = false;
   }

   openItem(event: Event, item: any) {
      this.navigatingAway = true;
      event.stopPropagation();
      this.clickitem.emit(item);
   }

   onItemClickMenu(event: any, item: any) {
      event.preventDefault();
      this.isCheck = false;
      this.items.forEach(o => {
         o.selected = false;
         const indexDel = this.selectedItems.indexOf(o);
         if (indexDel !== -1) {
            this.selectedItems.splice(indexDel, 1);
         }
      });
      item.selected = true;
      if (this.selectedItems.indexOf(item) === -1) {
         this.selectedItems.push(item);
      }
   }

   beginRename(item: any) {
      this.resetRename();// reset old rename not done
      this.canDrag = false;
      item.editing = true;
      setTimeout(() => {
         const input = $('#edit-' + item.id).focus()[0];
         let i;
         if (item.mimeType !== 'application/vnd.google-apps.folder') {
            if(item.mimeType === 'application/vnd.google-apps.spreadsheet' || item.mimeType === 'application/vnd.google-apps.presentation' || item.mimeType === 'application/vnd.google-apps.document') {
               i = item.name.length;
            }else{
               i = item.name.lastIndexOf('.');
               if (i === -1) {
                  i = item.name.length;
               } else {
                  this.extention = item.name.split('.')[item.name.split('.').length - 1];
               }
            }
         } else {
            i = item.name.length;
         }
         const fileName = item.name.slice(0, i);
         item.name = fileName;
         if (input.setSelectionRange) {
            input.setSelectionRange(0, i);
         } else if (input.createTextRange) {
            const range = input.createTextRange();
            range.collapse(true);
            range.moveEnd('character', i);
            range.moveStart('character', 0);
            range.select();
         } else if (input.selectionStart) {
            input.selectionStart = 0;
            input.selectionEnd = i;
         }
      }, 200);
   }

   endRename(item: any) {
      this.canDrag = true;
      item.editing = false;
      this.extention = '';
   }

   resetRename(){
      this.items.forEach(item_state => {
         if(item_state.editing){
            //reset Name old rename not finish
            item_state.name += "."+this.extention;
            this.endRename(item_state);
         }
      });
   }

   renameKeyDown(event: KeyboardEvent, item: any) {
      if (event.key === 'Enter') {
         this.rename(item);
      } else if (event.key === 'Escape') {
         $('#edit-' + item.id).val(item.name);
         this.endRename(item);
      }
   }

   rename(item: any) {
      const value = $('#edit-' + item.id).val().trim();
      if (value.length === 0) {
         return;
      } else if (item.name === value) {
         if (this.extention !== '' && this.extention !== undefined && (item.mimeType !== 'application/vnd.google-apps.folder')) {
            item.name += '.' + this.extention;
         }
         this.endRename(item);
      } else if (/[<|>\\\/:?*"]/g.test(value)) {
         this.translate.get('alert.create_folder_error').subscribe(s => {
            this.toast.error(s);
         });
         return;
      } else {
         let update;
         if (this.extention !== '' && this.extention !== undefined && (item.mimeType !== 'application/vnd.google-apps.folder')) {
            update = value + '.' + this.extention;
            this.renameDriveFile(item, update);
         } else {
            if (this.extention && item.mimeType !== 'application/vnd.google-apps.folder') {
               update = `${value}.${this.extention}`;
            } else if (item.mimeType === 'application/vnd.google-apps.folder' || item.mimeType === 'application/vnd.google-apps.spreadsheet' || item.mimeType === 'application/vnd.google-apps.presentation' || item.mimeType === 'application/vnd.google-apps.document') {
               update = value;
            }
            this.renameDriveFile(item, update);
         }
      }
   }

   renameDriveFile(item: any, newName: any) {
      const promise =  this.service.updateFileGoogleDrive(item.id, newName, this.access_token).toPromise()
         .then(res => {
            item.name = newName;
            this.endRename(item);
         })
         .catch(error => {
            if (error.status === 401) {
               this.toast.error('Access token has expired or is not yet valid.');
            } else {
               this.translate.get('uploadDoc.errorPdf').subscribe(s => {
                  this.toast.error(s);
               });
            }
         });
   }

   protected async confirmDelete(item: any) {
      const dialogRef = this.dialog.open(ConfirmDeleteComponent, {
         disableClose: true,
         data: {service: this.service, item: item,
            toast: this.toast,
            translate: this.translate,
            access_token_google_drive: this.access_token,
            message: await this.translate.get("google.message.delete").toPromise()}
      });
      dialogRef.afterClosed().subscribe(result => {
         if (result) {
            const i = this.items.indexOf(item);
            if (i !== -1) {
               this.selectedItems.forEach(o => {
                  const indexDel = this.items.indexOf(o);
                  if (indexDel !== -1) {
                     this.items[indexDel].selected = false;
                  }
                  this.selectedItems.splice(0, 1);
               });
               this.items.splice(i, 1);
            }
         }
      });
   }

   download(item: any) {
      const promise =  this.service.downloadGoogleDrive(item.id, item.mimeType, this.access_token).toPromise()
         .then(res => {
            let url = window.URL.createObjectURL(res);
            let a = document.createElement('a');
            document.body.appendChild(a);
            a.setAttribute('style', 'display: none');
            a.href = url;
            a.download = item.name;
            a.click();
            window.URL.revokeObjectURL(url);
            a.remove();
         })
         .catch(error => {
            if (error.status === 401) {
               this.toast.error('Access token has expired or is not yet valid.');
            } else {
               this.translate.get('uploadDoc.errorPdf').subscribe(s => {
                  this.toast.error(s);
               });
            }
         });
   }

   /**
    *
    * @detail : When key down on keyboard 'A' button thumbnails will be selected all button
    * and when key down on keyboard 'D' button thumbnails will be unselected all button.
    */

   @HostListener('document:keydown', ['$event'])
   onKeyDown(e: KeyboardEvent) {
      if (e.shiftKey) {
         this.shiftPressed = true;
      } else if (e.key === 'a' && (e.ctrlKey || e.metaKey)) {
         if (this.canDrag) {
            e.preventDefault();
            e.stopPropagation();
            this.items.forEach(o => {
               o.selected = true;
               const index = this.selectedItems.indexOf(o);
               if (index === -1) {
                  this.selectedItems.push(o);
               }
            });
         }
      } else if (e.key === 'd' && (e.ctrlKey || e.metaKey)) {
         if (this.canDrag) {
            e.preventDefault();
            e.stopPropagation();
            this.items.forEach(o => {
               o.selected = false;
               const index = this.selectedItems.indexOf(o);
               if (index !== -1) {
                  this.selectedItems.splice(index, 1);
               }
            });
            if (this.activeItem) {
               this.activeItem = this.info = undefined;
            }
         }
      }
   }

   @HostListener('document:keyup', ['$event'])
   onKeyUp(e: KeyboardEvent) {
      if (e.shiftKey) {
         this.shiftPressed = false;
      }
   }

   getIcon(item: any): string {
      return Mimetype.getIconGoogleDrive(item);
   }

   getMimeTypeDownload(item: any): string {
      switch (item.mimeType) {
         case 'application/vnd.google-apps.spreadsheet':
            return item.exportLinks['application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'];
         case 'application/vnd.google-apps.presentation':
            return item.exportLinks['application/vnd.openxmlformats-officedocument.presentationml.presentation'];
         case 'application/vnd.google-apps.document':
            return item.exportLinks['application/zip'];
      }
      return item.exportLinks['application/zip'];
   }

   getMimeTypeExtension(item: any): string {
      switch (item.mimeType) {
         case 'application/vnd.google-apps.spreadsheet':
            return '.xlsx';
         case 'application/vnd.google-apps.presentation':
            return '.pptx';
         case 'application/vnd.google-apps.document':
            return '.docx';
      }
      return '';
   }

   openSelectedMove(item, i) {
      this.movedialog = this.dialog.open(GoogleDriveMoveDialogComponent, {
         disableClose: true,
         data: {itemToMove: item, access_token: this.access_token}
      });
      this.movedialog.afterClosed().subscribe(result => {
         if (result) {
            this.loading = true
            this.selectedItems = [];
            this.showdocument.emit();
         }
      });
   }

   toggleLoading(){
      this.loading = true;
   }

   @HostListener('window:scroll')
   onWindowScroll() {
      if (this.navigatingAway) {
         this.navigatingAway = false;
         return;
       }
      if (this.hasMore && !this.loading) {
         if (window.innerHeight + window.pageYOffset + 1 >= document.body.scrollHeight) {
            this.loading = true;
            this.loadmore.emit();
         }
      }

      this.adjustInfoPosition();
   }

   private adjustInfoPosition() {
      const info = $('.info-body:visible');
      if (info.length === 0) {
         return;
      }

      let title = $('.info-title');
      if (this.shared) {
         title = $('.info-title-share');
      }
      const infoTop = title.position().top + title.outerHeight(true);
      const top = infoTop + 'px';
      if (window.scrollY > 0) {
         // TODO: detect scroll direction and use to calc position instead of window.scrollY
         const height = info.outerHeight(true);
         if (window.innerHeight - infoTop - height < 0) {
            const x = window.innerHeight - this.spacer;
            let y = infoTop - window.scrollY;
            if (y + height < x) {
               y = x - height;
            }
         }
      }
   }
}
